<template>
    <div class="taskCenter">
          <el-tabs type="card" tab-position="left" @tab-click="handleClick" v-model="activeName">
            <el-tab-pane label="工作通知" name="pending">
                <div class="main">
                    <easyCruds ref="pendingTable" :tableInfo="pendingForm.mainTable"
                            @mainTableReload="pendingTableReload"
                            @handleRow="handleRow"
                            >
                    </easyCruds>
                </div>
            </el-tab-pane>
            <el-tab-pane label="通知公告" name="processed">
                <div class="main">
                    <easyCruds ref="processedTable" :tableInfo="processedForm.mainTable"
                            @mainTableReload="processedTableReload"
                            @processedViewRow="processedViewRow"
                            >
                    </easyCruds>
                </div>
            </el-tab-pane>
            <el-tab-pane label="互动通知" name="application">
                <div class="main">
                    <easyCruds ref="applicationTable" :tableInfo="applicationForm.mainTable"
                            @mainTableReload="applicationTableReload"
                            @applicationViewRow="applicationViewRow"
                            >
                    </easyCruds>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: 'pending',
      pendingForm: {
        mainTable: {
          buttonSetting: {
            allowView: false,
            allowEdit: false,
            allowDelete: false
          },
          header: {},
          table: {
            loading: false,
            height: 550,
            stripe: true,
            conditionLabelWidth: '120px',
            selection: false,
            index: false,
            columns: [
              {
                label: '消息内容',
                prop: 'processInstanceStartUserName'
              },
              {
                label: '发送时间',
                prop: 'processInstanceName'
              },
              {
                label: '流程名称',
                prop: 'processDefinitionKey',
                isSearchCondition: false,
                type: 'cascader',
                showInTable: false,
                filterable: true,
                dicData: [],
                showInTable: false
              },
              {
                label: '信息查询',
                prop: 'taskName',
                showInTable: false,
                isSearchCondition: true
              },
              {
                label: '环节开始时间',
                prop: 'taskCreateTime',
                showInTable: false,
                dataFilter: function(value) {
                  if (value) return value.split('T')[0]
                }
              }
            ],
            operation: {
              width: '220',
              operations: [

              ]
            },
            tableData: [],
            paging: {
              currentPage: 1,
              pageSizes: [10, 15, 20, 25],
              pageSize: 10,
              total: 0
            },
            reload: 'mainTableReload',
            reloadConditions: {},
            addDefultValue: {}
          }
        }
      },
      processedForm: {
        mainTable: {
          buttonSetting: {
            allowView: false,
            allowEdit: false,
            allowDelete: false
          },
          header: {},
          table: {
            loading: false,
            height: 550,
            stripe: true,
            conditionLabelWidth: '120px',
            selection: false,
            index: false,
            columns: [
              {
                label: '消息内容',
                prop: 'processInstanceStartUserName'
              },
              {
                label: '发送时间',
                prop: 'processInstanceName'
              },
              {
                label: '流程名称',
                prop: 'processDefinitionKey',
                isSearchCondition: false,
                type: 'cascader',
                showInTable: false,
                filterable: true,
                dicData: [],
                showInTable: false
              },
              {
                label: '信息查询',
                prop: 'taskName',
                showInTable: false,
                isSearchCondition: true
              }
            ],
            operation: {
              width: '220',
              operations: []
            },
            tableData: [],
            paging: {
              currentPage: 1,
              pageSizes: [10, 15, 20, 25],
              pageSize: 10,
              total: 0
            },
            reload: 'mainTableReload',
            reloadConditions: {},
            addDefultValue: {}
          }
        }
      },
      applicationForm: {
        mainTable: {
          buttonSetting: {
            allowView: false,
            allowEdit: false,
            allowDelete: false
          },
          header: {},
          table: {
            loading: false,
            height: 550,
            stripe: true,
            conditionLabelWidth: '120px',
            selection: false,
            index: false,
            columns: [
              {
                label: '消息内容',
                prop: 'processInstanceStartUserName'
              },
              {
                label: '发送时间',
                prop: 'processInstanceName'
              },
              {
                label: '流程名称',
                prop: 'processDefinitionKey',
                isSearchCondition: false,
                type: 'cascader',
                showInTable: false,
                filterable: true,
                dicData: [],
                showInTable: false
              },
              {
                label: '信息查询',
                prop: 'taskName',
                showInTable: false,
                isSearchCondition: true
              }
            ],
            operation: {
              width: '220',
              operations: [

              ]
            },
            tableData: [],
            paging: {
              currentPage: 1,
              pageSizes: [10, 15, 20, 25],
              pageSize: 10,
              total: 0
            },
            reload: 'mainTableReload',
            reloadConditions: {},
            addDefultValue: {}
          }
        }
      }
    }
  },
  methods: {
    load(params, url, data) {
      this[data].mainTable.table.loading = true
      params = params || {}
      // params.jszgh=this.jszgh;
      this[data].mainTable.table.loading = true
      if (!params.pageSize) { params.pageSize = 10 }
      if (!params.pageNum) { params.pageNum = 1 }
      this.$http.get(url, {
        params
      }).then(
        response => {
          this[data].mainTable.table.loading = false
          if (response.code === 200) {
            // 成功之后的数据
            this[data].mainTable.table.tableData = response.data.records
            this[data].mainTable.table.paging.total = response.data.total || response.data.records.length
            return true
          } else {
            this.$message.error(response.msg)
          }
        }
      ).catch(
        error => {
          this[data].mainTable.table.loading = false
        }
      )
    },
    pendingTableReload(params) {
      this.load(params, '/flow-ext/my-todo-and-wait-me-claim', 'pendingForm')
    },
    processedTableReload(params) {
      this.load(params, '/flow-ext/i-did-apply', 'processedForm')
    },
    applicationTableReload(params) {
      this.load(params, '/flow-ext/my-apply', 'applicationForm')
    },
    handleClick(tab, event) {
      // this.activeName=tab.name;

    },
    getSelectData(url, label, value, columns, prop, params, method) {
      method = method || 'get'
      params = params || {}
      let HTTP = method === 'post' ? this.$http[method](url, null, { params }) : this.$http[method](url, { params })
      let column = this[columns].mainTable.table.columns
      let index = this.findArray(column, prop, 'prop')
      HTTP.then(res => {
        let arrDate = []
        res.data.forEach(element => {
          arrDate.push({
            label: element[label],
            value: element[value]
          })
        })
        column[index].dicData = arrDate
      })
    },
    // 我的申请查看
    applicationViewRow(index, row) {
      this.$router.push({
        name: 'workFlow-view-myApply',
        params: {
          row: row,
          pageKey: 'VIEW'
        }
      })
    },
    // 我的待办办理
    handleRow(index, row) {
      this.$router.push({
        name: 'workFlow-view-myApply',
        params: {
          row: row,
          pageKey: 'DO'
        }
      })
    },
    // 我已处理查看
    processedViewRow(index, row) {
      this.$router.push({
        name: 'workFlow-view-myApply',
        params: {
          row: row,
          pageKey: 'VIEW'
        }
      })
    }
  },
  mounted() {
    this.pendingTableReload({})
    this.processedTableReload({})
    this.applicationTableReload({})

    this.getSelectData('flow-ext/process-definition-list', 'name', 'key', 'applicationForm', 'processDefinitionKey', { involvedMe: 'true' })
    this.getSelectData('flow-ext/process-definition-list', 'name', 'key', 'processedForm', 'processDefinitionKey', { involvedMe: 'true' })
    this.getSelectData('flow-ext/process-definition-list', 'name', 'key', 'pendingForm', 'processDefinitionKey', { involvedMe: 'true' })
  }
}
</script>
<style lang="scss">
    // .theme-longyun .avue-contail, .theme-longyun .avue-main {
    //     margin-top: 0;
    // }
    .taskCenter{
        margin-top: 15px;
    }
</style>
<style lang="scss" scoped>
    .taskCenter{
        max-width: 1680px;
        width: calc(100% - 340px);
        min-width: 1280px;
        margin: auto;
        margin-top: 15px !important;
    }
    :deep(.el-form-item__label) {
        color: #333;
    }
    .taskCenter{
        :deep(.el-tabs--card){
            .el-tabs__header{
                width: 160px;
                margin-right: 15px;
                .el-tabs__nav {
                    border:0;
                    .el-tabs__item{
                        height:48px;
                        background: #fff;
                        color: #666;
                        line-height: 48px;
                        text-align: center;
                        font-size: 16px;
                        border-right: 0;
                        &:last-child{
                            border-bottom: 0;
                        }
                    }
                    .el-tabs__item.is-active{
                        background: #1871db;
                        color:#fff;
                    }
                }
            }
            .el-tabs__content{
                background: #fff;
                border-radius: 5px;
                min-height: calc(100vh - 190px);
                padding: 30px;
                .el-tab-pane{
                    .el-form{
                        .el-form-item{
                            .el-form-item__label{
                                font-weight: 700;
                                font-size:16px;
                            }
                            .el-input.is-active .el-input__inner, .el-input__inner:focus {
                                border-color: #1871db;
                                outline: 0;
                            }
                            .el-button{
                                font-size: 16px;
                                color:#fff;
                                background: #1871db;
                                border:0;
                                height: 36px;
                                padding: 0 10px;
                                &:last-child{
                                    background: #bababa;
                                }
                            }
                            input::-webkit-input-placeholder {
                                font-size: 16px;
                            }
                            input:-ms-input-placeholder { // IE10+
                                font-size: 16px;
                            }
                            input:-moz-placeholder { // Firefox4-18
                                font-size: 16px;
                            }
                            input::-moz-placeholder { // Firefox19+
                                font-size: 16px;
                            }
                        }
                    }
                    .main{
                        .el-card.is-always-shadow{
                            box-shadow:none;
                            .el-card__body{
                                &>.el-row{
                                    .el-input__inner{
                                        font-size: 16px;
                                    }
                                    .el-form{
                                        &>div{
                                            margin-right: 20px;
                                        }
                                        .el-form-item__content{
                                            white-space: nowrap;
                                        }
                                    }
                                }
                                .el-table{
                                    th{
                                        background: #f4f4f4;
                                    }
                                    .has-gutter>tr>th{
                                        font-size:16px;
                                        background: #f4f4f4;
                                        border-right: 0;
                                    }
                                    .el-table__body-wrapper{
                                        tbody{
                                            color: #999;
                                            font-size: 15px;
                                            td{
                                                .cell{
                                                    border-right: 0;
                                                }
                                            }
                                        }
                                        .el-table__row--striped{
                                            background: #fafafa;
                                        }
                                    }
                                    .el-table__fixed-right{
                                        .el-table__fixed-body-wrapper{
                                            top:44px!important;
                                            .el-button--text{
                                                color:#1871db;
                                                // font-size: 15px;
                                            }
                                            .el-button{
                                                // padding:0;
                                                // line-height: 30px;
                                            }
                                        }
                                    }
                                }
                                nav{
                                    .el-pagination{
                                        .number.active{
                                            background: #1871db;
                                        }
                                        .el-select .el-input__inner:focus {
                                            border-color: #1871db;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

</style>
